import React from "react";
import usePasses from "../../Passes/hooks/usePasses";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import SinglePass from "../../Passes/SinglePass";

interface IProps {
  saleStep: SaleStep;
}

const PassModule: React.FC<IProps> = ({ saleStep }) => {
  const { passes, selectedDate, setDateBetween, loading } = usePasses({ assortIds: saleStep.assortIds });

  if (loading) return <EASkeletonLoader height="200px" />;

  if (passes.length > 0)
    return (
      <div className="module-list">
        {passes.map((item) => (
          <SinglePass
            key={item.objectId}
            item={item}
            selectedDate={selectedDate}
            setDateBetween={setDateBetween}
            isHorizontal
          />
        ))}
      </div>
    );

  return <></>;
};

export default PassModule;
